<template>
    <div class="tags">
        <el-tag
            :key="tag"
            effect="plain"
            type="primary"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
        >
            {{ tag }}
        </el-tag>
        <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-if="dynamicTags.length < denominator" class="button-new-tag" size="small" @click="showInput">+ 添加候选项</el-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            inputVisible: false,
            inputValue: ''
        };
    },
    props: {
        dynamicTags: Array,
        numerator: Number,
        denominator: Number
    },
    methods: {
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            if (this.numerator > this.denominator) {
                return this.$message.error('代表项不能大于候选项');
            }
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            // this.$emit('push', this.dynamicTags);
        }
    }
};
</script>
<style lang="scss" scoped>
.tags {
    margin-top: 20px;
    .el-tag {
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        color: #606266;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
}
</style>
